// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"395":"4c2fa7b7","461":"e64de5d4","808":"3e179111"}[chunkId] + ".chunk.js";
};